import Axios from './APIService';
import { AxiosPromise, AxiosRequestConfig } from 'axios';

import Item from '@/types/Item';
import ItemInformation from '@/types/ItemInformation';
import Price from '@/types/Price';

const admin = '/admin';

const apiBase = '/items';

const ItemAPI = {

    getItems(): AxiosPromise<Item[]> {
        return Axios.get(apiBase);
    },

    get(): AxiosPromise<Item[]> {
        return Axios.get(`${admin}${apiBase}`);
    },

    getItem(itemId: string): AxiosPromise<Item[]> {
        return Axios.get(`${admin}${apiBase}/${itemId}`);
    },

    postItem(item: Item): AxiosPromise<Item> {
        return Axios.post(`${admin}${apiBase}`, item);
    },

    putItem(itemId: string, item: Item): AxiosPromise<Item> {
        return Axios.put(`${admin}${apiBase}/${itemId}`, item);
    },

    deleteItem(itemId: string): AxiosPromise<Item> {
        return Axios.delete(`${admin}${apiBase}/${itemId}`);
    },

    postImage(itemId: string, formData: FormData, config: AxiosRequestConfig): AxiosPromise<Item> {
        return Axios.post(`${admin}${apiBase}/${itemId}/images`, formData, config);
    },

    deleteImage(itemId: string, imageId: string): AxiosPromise<Item> {
        return Axios.delete(`${admin}${apiBase}/${itemId}/images/${imageId}`);
    },

    postIconImage(itemId: string, formData: FormData, config: AxiosRequestConfig): AxiosPromise<Item> {
        return Axios.post(`${admin}${apiBase}/${itemId}/iconImage`, formData, config);
    },

    deleteIconImage(itemId: string): AxiosPromise<Item> {
        return Axios.delete(`${admin}${apiBase}/${itemId}/iconImage`);
    },

    postItemInformations(itemId: string, itemInformations: ItemInformation[]): AxiosPromise<Item> {
        return Axios.post(`${admin}${apiBase}/${itemId}/informations`, itemInformations);
    },

    putItemInformation(
            itemId: string,
            itemInformationId: string,
            itemInformation: ItemInformation): AxiosPromise<Item> {
        return Axios.put(`${admin}${apiBase}/${itemId}/informations/${itemInformationId}`, itemInformation);
    },

    deleteItemInformation(itemId: string, itemInformationId: string): AxiosPromise<Item> {
        return Axios.delete(`${admin}${apiBase}/${itemId}/informations/${itemInformationId}`);
    },

    postPrice(itemId: string, price: Price): AxiosPromise<Item> {
        return Axios.post(`${admin}${apiBase}/${itemId}/prices`, price);
    },

};

export default ItemAPI;
